import React, { useState, useRef, useEffect } from "react";
import PortfolioBackground from "./PortfolioBackground";
import AutoVideo from "./AutoVideo";
import { withV } from "../lib/media";
import Flyers360 from "./blocks/Flyers360";
import { PayBlock, BuyButton, isStripeUrl } from "./blocks/Pay";
import MosaicHorizontal from "./blocks/MosaicHorizontal";
import Reveal from "./Reveal";
import { CoverHeader } from "./CoverHeader";
import {
  VCardBlock,
  ReviewsBlock,
  MenuBlock,
  CountdownBlock,
  TimelineBlock,
  AudioBlock,
  StoriesBlock,
  ImageBlock,
  QrBlock,
} from "./blocks/NewBlocks";
import {
  MessageCircle,
  Mail,
  Link as LinkIcon,
  MapPin,
  Navigation,
  Instagram,
  Facebook,
  Youtube,
  Linkedin,
  Play,
  BadgeCheck,
  Star,
  Crown,
  Heart,
  Award,
  Music2,
  Globe,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  Share2,
  CalendarClock,
  DollarSign,
  ShoppingCart,
  ShoppingBag,
  CreditCard,
  Gift,
  Ticket,
  Download,
  Info,
  HelpCircle,
  Clock,
  Send,
  Phone,
  Percent,
  Tag,
  Store,
  Sparkles,
  ThumbsUp,
  Twitter,
  FileText as PdfIcon,
} from "lucide-react";
import { PdfViewer } from "./PdfViewer";
import {
  FaWhatsapp,
  FaFacebookF,
  FaInstagram,
  FaTiktok,
  FaXTwitter,
  FaYoutube,
  FaLinkedinIn,
  FaTelegram,
  FaFacebookMessenger,
  FaSnapchat,
  FaPinterestP,
  FaThreads,
  FaDiscord,
  FaTwitch,
  FaSpotify,
  FaRedditAlien,
  FaWaze,
} from "react-icons/fa6";
import { SiMercadopago, SiGmail } from "react-icons/si";

// Iconos disponibles para los botones (logos reales de redes + significativos)
export const BUTTON_ICONS = [
  { key: "whatsapp", label: "WhatsApp", Icon: FaWhatsapp, color: "#25D366", brand: true },
  { key: "facebook", label: "Facebook", Icon: FaFacebookF, color: "#1877F2", brand: true },
  { key: "instagram", label: "Instagram", Icon: FaInstagram, color: "#E4405F", brand: true },
  { key: "tiktok", label: "TikTok", Icon: FaTiktok, color: "#010101", brand: true },
  { key: "x", label: "X (Twitter)", Icon: FaXTwitter, color: "#000000", brand: true },
  { key: "youtube", label: "YouTube", Icon: FaYoutube, color: "#FF0000", brand: true },
  { key: "linkedin", label: "LinkedIn", Icon: FaLinkedinIn, color: "#0A66C2", brand: true },
  { key: "telegram", label: "Telegram", Icon: FaTelegram, color: "#26A5E4", brand: true },
  { key: "messenger", label: "Messenger", Icon: FaFacebookMessenger, color: "#0084FF", brand: true },
  { key: "snapchat", label: "Snapchat", Icon: FaSnapchat, color: "#111827", brand: true },
  { key: "pinterest", label: "Pinterest", Icon: FaPinterestP, color: "#BD081C", brand: true },
  { key: "threads", label: "Threads", Icon: FaThreads, color: "#000000", brand: true },
  { key: "discord", label: "Discord", Icon: FaDiscord, color: "#5865F2", brand: true },
  { key: "twitch", label: "Twitch", Icon: FaTwitch, color: "#9146FF", brand: true },
  { key: "spotify", label: "Spotify", Icon: FaSpotify, color: "#1DB954", brand: true },
  { key: "reddit", label: "Reddit", Icon: FaRedditAlien, color: "#FF4500", brand: true },
  { key: "website", label: "Sitio web", Icon: Globe, color: "#2E6BFF" },
  { key: "mercadolibre", label: "Mercado Libre", Icon: SiMercadopago, color: "#FFE600", brand: true },
  { key: "gmail", label: "Gmail", Icon: SiGmail, color: "#EA4335", brand: true },
  { key: "phone", label: "Teléfono", Icon: Phone, color: "#2E6BFF" },
  { key: "mail", label: "Correo", Icon: Mail, color: "#2E6BFF" },
  { key: "link", label: "Enlace", Icon: LinkIcon, color: "#2E6BFF" },
  { key: "location", label: "Ubicación", Icon: MapPin, color: "#2E6BFF" },
  { key: "dollar", label: "Signo de pesos", Icon: DollarSign, color: "#16A34A" },
  { key: "cart", label: "Carrito", Icon: ShoppingCart, color: "#2E6BFF" },
  { key: "bag", label: "Bolsa de compra", Icon: ShoppingBag, color: "#2E6BFF" },
  { key: "card", label: "Tarjeta / pago", Icon: CreditCard, color: "#2E6BFF" },
  { key: "calendar", label: "Agendar", Icon: CalendarClock, color: "#2E6BFF" },
  { key: "offer", label: "Oferta / %", Icon: Percent, color: "#F59E0B" },
  { key: "tag", label: "Etiqueta / precio", Icon: Tag, color: "#2E6BFF" },
  { key: "gift", label: "Regalo", Icon: Gift, color: "#EC4899" },
  { key: "ticket", label: "Boleto / cupón", Icon: Ticket, color: "#2E6BFF" },
  { key: "download", label: "Descargar", Icon: Download, color: "#2E6BFF" },
  { key: "star", label: "Estrella", Icon: Star, color: "#F59E0B" },
  { key: "heart", label: "Corazón", Icon: Heart, color: "#EF4444" },
  { key: "store", label: "Tienda", Icon: Store, color: "#2E6BFF" },
  { key: "clock", label: "Horario", Icon: Clock, color: "#2E6BFF" },
  { key: "info", label: "Información", Icon: Info, color: "#2E6BFF" },
];

export const buttonIconEntry = (key) =>
  BUTTON_ICONS.find((i) => i.key === key) || null;

export const buttonIconFor = (key) => buttonIconEntry(key)?.Icon || null;

const hexToRgba = (hex, alpha = 1) => {
  const h = (hex || "").replace("#", "");
  if (h.length !== 6) return hex;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const BADGE_STYLES = {
  check: { icon: BadgeCheck, bg: "bg-blue-500" },
  star: { icon: Star, bg: "bg-amber-500" },
  crown: { icon: Crown, bg: "bg-yellow-500" },
  heart: { icon: Heart, bg: "bg-rose-500" },
  award: { icon: Award, bg: "bg-emerald-500" },
};

// Logos de marca (react-icons/fa6) con su color oficial
export const SOCIAL_BRAND = {
  instagram: { Icon: FaInstagram, color: "#E4405F" },
  facebook: { Icon: FaFacebookF, color: "#1877F2" },
  youtube: { Icon: FaYoutube, color: "#FF0000" },
  linkedin: { Icon: FaLinkedinIn, color: "#0A66C2" },
  tiktok: { Icon: FaTiktok, color: "#010101" },
  whatsapp: { Icon: FaWhatsapp, color: "#25D366" },
  telegram: { Icon: FaTelegram, color: "#26A5E4" },
  messenger: { Icon: FaFacebookMessenger, color: "#0084FF" },
  snapchat: { Icon: FaSnapchat, color: "#111827" },
  pinterest: { Icon: FaPinterestP, color: "#BD081C" },
  threads: { Icon: FaThreads, color: "#000000" },
  discord: { Icon: FaDiscord, color: "#5865F2" },
  twitch: { Icon: FaTwitch, color: "#9146FF" },
  spotify: { Icon: FaSpotify, color: "#1DB954" },
  reddit: { Icon: FaRedditAlien, color: "#FF4500" },
  x: { Icon: FaXTwitter, color: "#000000" },
  website: { Icon: Globe, color: "#2E6BFF" },
};

const socialBrand = (platform) =>
  SOCIAL_BRAND[platform] || { Icon: Globe, color: "#2E6BFF" };

const getYoutubeId = (url = "") => {
  const m = url.match(
    /(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/)([\w-]{11})/
  );
  return m ? m[1] : null;
};

const getVimeoId = (url = "") => {
  const m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  return m ? m[1] : null;
};

const getTikTokId = (url = "") => {
  const m = url.match(/tiktok\.com\/(?:.*\/video\/|v\/|embed\/v2\/)(\d{6,})/);
  return m ? m[1] : null;
};

const getInstagramEmbed = (url = "") => {
  const m = url.match(/instagram\.com\/(p|reel|reels|tv)\/([\w-]+)/);
  if (!m) return null;
  const type = m[1] === "reels" ? "reel" : m[1];
  return `https://www.instagram.com/${type}/${m[2]}/embed`;
};

const getFacebookEmbed = (url = "") => {
  if (!/facebook\.com|fb\.watch/.test(url)) return null;
  return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=false`;
};

const isDirectVideo = (url = "") =>
  /\.(mp4|webm|ogg|mov|m4v)(\?|$)/i.test(url) || /\/api\/files\//.test(url);

const buildHref = (block) => {
  if (block.variant === "whatsapp") {
    const phone = (block.value || "").replace(/[^\d]/g, "");
    const text = block.message ? `?text=${encodeURIComponent(block.message)}` : "";
    return `https://wa.me/${phone}${text}`;
  }
  if (block.variant === "email") return `mailto:${block.value}`;
  return block.value;
};

const PdfAwareLink = ({ block, className, style, children }) => {
  const [open, setOpen] = useState(false);
  if (block.variant !== "pdf") {
    return (
      <a href={buildHref(block)} target="_blank" rel="noopener noreferrer" className={className} style={style}>
        {children}
      </a>
    );
  }
  return (
    <>
      <button type="button" onClick={() => block.value && setOpen(true)} className={`${className} w-full`} style={style} data-testid="pdf-button">
        {children}
      </button>
      {open && <PdfViewer url={block.value} title={block.label} onClose={() => setOpen(false)} />}
    </>
  );
};

const SectionHeading = ({ children, style, animClass = "", titleSize, align = "center" }) => {
  const fontStyle = { ...style, ...(titleSize ? { fontSize: `${titleSize}px` } : {}) };
  if (align && align !== "center") {
    return (
      <h2
        className={`font-display text-sm font-semibold uppercase leading-tight tracking-[0.2em] text-white/90 break-words ${animClass}`}
        style={{ textAlign: align, width: "100%", ...fontStyle }}
      >
        {children}
      </h2>
    );
  }
  return (
    <div className="flex items-center justify-center gap-3 pt-2">
      <span className="h-px w-8 shrink-0 bg-white/30" />
      <h2
        className={`font-display text-sm font-semibold uppercase leading-tight tracking-[0.2em] text-white/90 break-words text-center ${animClass}`}
        style={fontStyle}
      >
        {children}
      </h2>
      <span className="h-px w-8 shrink-0 bg-white/30" />
    </div>
  );
};

const textStyleFrom = (b) => ({
  fontFamily: b.fontFamily || undefined,
  color: b.color || undefined,
  fontSize: b.fontSize ? `${b.fontSize}px` : undefined,
  letterSpacing: typeof b.letterSpacing === "number" ? `${b.letterSpacing}em` : undefined,
  textAlign: b.align || undefined,
  paddingTop: typeof b.padY === "number" ? `${b.padY}px` : undefined,
  paddingBottom: typeof b.padY === "number" ? `${b.padY}px` : undefined,
  paddingLeft: typeof b.padX === "number" ? `${b.padX}px` : undefined,
  paddingRight: typeof b.padX === "number" ? `${b.padX}px` : undefined,
});
const animClassFrom = (b) => (b.anim && b.anim !== "none" ? `txt-anim-${b.anim}` : "");

const ProductCarousel = ({ block }) => {
  const [idx, setIdx] = useState(0);
  const items = block.items || [];
  const go = (dir) => {
    setIdx((prev) => (prev + dir + items.length) % items.length);
  };
  if (!items.length) return null;
  return (
    <div className="w-full">
      {block.title && <SectionHeading titleSize={block.titleSize}>{block.title}</SectionHeading>}
      {block.subtitle && (
        <p className="mt-2 text-center text-sm text-white/60" style={block.subtitleSize ? { fontSize: `${block.subtitleSize}px` } : undefined}>{block.subtitle}</p>
      )}
      <div className="relative mt-4 overflow-hidden rounded-2xl">
        <div
          className="flex transition-transform duration-500 ease-out"
          style={{ transform: `translateX(-${idx * 100}%)` }}
        >
          {items.map((it) => (
            <a
              key={it.id}
              href={it.link || "#"}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative block min-w-full"
            >
              <img
                src={it.image}
                alt={it.title}
                className="h-64 w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <p className="font-display text-lg font-semibold text-white">
                  {it.title}
                </p>
              </div>
            </a>
          ))}
        </div>
        {items.length > 1 && (
          <>
            <button
              onClick={() => go(-1)}
              className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-black/40 p-2 text-white backdrop-blur transition hover:bg-black/70"
              aria-label="Anterior"
            >
              <ChevronLeft className="h-5 w-5" />
            </button>
            <button
              onClick={() => go(1)}
              className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-black/40 p-2 text-white backdrop-blur transition hover:bg-black/70"
              aria-label="Siguiente"
            >
              <ChevronRight className="h-5 w-5" />
            </button>
          </>
        )}
      </div>
      {items.length > 1 && (
        <div className="mt-3 flex justify-center gap-1.5">
          {items.map((it, i) => (
            <button
              key={it.id}
              onClick={() => setIdx(i)}
              className={`h-1.5 rounded-full transition-all ${
                i === idx ? "w-6 bg-blue-400" : "w-1.5 bg-white/30"
              }`}
              aria-label={`Ir a ${i + 1}`}
            />
          ))}
        </div>
      )}
      {items.some((x) => isStripeUrl(x.payLink)) && (
        <div className="mt-3 h-11">
          {isStripeUrl(items[idx]?.payLink) && (
            <BuyButton href={items[idx].payLink} label={`Comprar ahora · ${items[idx].title || ""}`} />
          )}
        </div>
      )}
    </div>
  );
};

const buildMapsHref = (block) => {
  if (block.mapUrl) return block.mapUrl;
  if (block.address)
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(block.address)}`;
  return "#";
};

const extractCoords = (url) => {
  if (!url) return null;
  const m =
    url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/) ||
    url.match(/[?&](?:q|query|ll|destination)=(-?\d+\.\d+),\s*(-?\d+\.\d+)/);
  return m ? `${m[1]},${m[2]}` : null;
};

const buildWazeHref = (block) => {
  const addr = (block.address || "").trim();
  if (addr && /^-?\d+\.\d+,\s*-?\d+\.\d+$/.test(addr))
    return `https://waze.com/ul?ll=${encodeURIComponent(addr.replace(/\s/g, ""))}&navigate=yes`;
  if (addr) return `https://waze.com/ul?q=${encodeURIComponent(addr)}&navigate=yes`;
  const coords = extractCoords(block.mapUrl);
  if (coords) return `https://waze.com/ul?ll=${coords}&navigate=yes`;
  return "https://waze.com/ul?navigate=yes";
};

const buildScheduleHref = (item) => {
  if (item.btnVariant === "whatsapp") {
    const phone = (item.btnValue || "").replace(/[^\d]/g, "");
    const text = item.btnMessage ? `?text=${encodeURIComponent(item.btnMessage)}` : "";
    return `https://wa.me/${phone}${text}`;
  }
  return item.btnValue || "#";
};

const ShowcaseCarousel = ({ block }) => {
  const [idx, setIdx] = useState(0);
  const items = block.items || [];
  const total = items.length;
  const go = (dir) => setIdx((prev) => (prev + dir + total) % total);
  if (!total) {
    return (
      <div className="w-full">
        {block.title && <SectionHeading titleSize={block.titleSize}>{block.title}</SectionHeading>}
        <p className="mt-4 text-center text-xs text-white/40">
          Agrega productos o servicios para ver la vitrina.
        </p>
      </div>
    );
  }
  const safeIdx = Math.min(idx, total - 1);
  return (
    <div className="w-full">
      {block.title && <SectionHeading titleSize={block.titleSize}>{block.title}</SectionHeading>}
      {block.subtitle && (
        <p className="mt-2 text-center text-sm text-white/60" style={block.subtitleSize ? { fontSize: `${block.subtitleSize}px` } : undefined}>{block.subtitle}</p>
      )}
      <div className="relative mt-4">
        <div className="overflow-hidden rounded-2xl">
          <div
            className="flex transition-transform duration-500 ease-out"
            style={{ transform: `translateX(-${safeIdx * 100}%)` }}
          >
            {items.map((it) => (
              <div key={it.id} className="min-w-full">
                <div className="overflow-hidden rounded-2xl border border-white/10 bg-white/5 backdrop-blur">
                  <div className="relative w-full" style={{ aspectRatio: "4 / 3" }}>
                    {it.mediaType === "video" && it.video ? (
                      <AutoVideo
                        src={it.video}
                        className="absolute inset-0 h-full w-full object-cover"
                      />
                    ) : it.image ? (
                      <img
                        src={it.image}
                        alt={it.title || ""}
                        className="absolute inset-0 h-full w-full object-cover"
                      />
                    ) : (
                      <div className="absolute inset-0 flex items-center justify-center bg-white/5 text-sm text-white/40">
                        Sin imagen / video
                      </div>
                    )}
                  </div>
                  <div className="p-4">
                    {it.title && (
                      <p className="text-center font-display text-base font-semibold text-white">
                        {it.title}
                      </p>
                    )}
                    {it.description && (
                      <p className="mt-1 text-center text-sm leading-relaxed text-white/65">
                        {it.description}
                      </p>
                    )}
                    {it.btnValue && (
                      <a
                        href={buildScheduleHref(it)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`mt-3 flex w-full items-center justify-center gap-2 rounded-xl py-2 text-sm font-semibold text-white transition hover:brightness-110 ${
                          it.btnVariant === "whatsapp" ? "bg-[#25D366]" : "bg-blue-600"
                        }`}
                      >
                        {it.btnVariant === "whatsapp" ? (
                          <FaWhatsapp className="h-4 w-4" />
                        ) : (
                          <CalendarClock className="h-4 w-4" />
                        )}
                        {it.btnLabel || "Agendar"}
                      </a>
                    )}
                    {isStripeUrl(it.payLink) && <BuyButton href={it.payLink} className="mt-2" />}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        {total > 1 && (
          <>
            <button
              onClick={() => go(-1)}
              className="absolute left-2 top-[36%] -translate-y-1/2 rounded-full bg-black/50 p-2 text-white backdrop-blur transition hover:bg-black/70"
              aria-label="Anterior"
            >
              <ChevronLeft className="h-5 w-5" />
            </button>
            <button
              onClick={() => go(1)}
              className="absolute right-2 top-[36%] -translate-y-1/2 rounded-full bg-black/50 p-2 text-white backdrop-blur transition hover:bg-black/70"
              aria-label="Siguiente"
            >
              <ChevronRight className="h-5 w-5" />
            </button>
          </>
        )}
      </div>
      {total > 1 && (
        <div className="mt-3 flex flex-wrap justify-center gap-1.5">
          {items.map((it, i) => (
            <button
              key={it.id}
              onClick={() => setIdx(i)}
              className={`h-1.5 rounded-full transition-all ${
                i === safeIdx ? "w-6 bg-blue-400" : "w-1.5 bg-white/30"
              }`}
              aria-label={`Ir a ${i + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const ShowcaseStrip = ({ block }) => {
  const scrollRef = useRef(null);
  const drag = useRef({ down: false, startX: 0, startLeft: 0, moved: false });
  const pausedRef = useRef(false);
  const items = block.items || [];
  const mode = block.stripMotion || "loop"; // loop | lateral | fixed
  // En modo bucle duplicamos las tarjetas para un desplazamiento infinito.
  const renderItems = mode === "loop" ? [...items, ...items] : items;

  // Autoavance: bucle continuo a la izquierda, vaivén lateral, o fijo.
  useEffect(() => {
    const el = scrollRef.current;
    if (!el || items.length < 2 || mode === "fixed") return;
    let dir = 1;
    const id = setInterval(() => {
      if (pausedRef.current) return;
      const max = el.scrollWidth - el.clientWidth;
      if (max <= 4) return;
      if (mode === "loop") {
        el.scrollLeft += 0.5;
        const half = el.scrollWidth / 2;
        if (el.scrollLeft >= half) el.scrollLeft -= half;
      } else {
        el.scrollLeft += dir * 0.6;
        if (el.scrollLeft >= max - 1) dir = -1;
        else if (el.scrollLeft <= 0) dir = 1;
      }
    }, 16);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items.length, mode]);

  if (!items.length) {
    return (
      <div className="w-full">
        {block.title && <SectionHeading titleSize={block.titleSize}>{block.title}</SectionHeading>}
        <p className="mt-4 text-center text-xs text-white/40">
          Agrega productos o servicios para ver la vitrina.
        </p>
      </div>
    );
  }

  const pause = () => {
    pausedRef.current = true;
  };
  const resume = () => {
    pausedRef.current = false;
  };
  const onDown = (e) => {
    const el = scrollRef.current;
    if (!el) return;
    pausedRef.current = true;
    drag.current = {
      down: true,
      startX: e.pageX,
      startLeft: el.scrollLeft,
      moved: false,
    };
  };
  const onMove = (e) => {
    if (!drag.current.down || !scrollRef.current) return;
    const dx = e.pageX - drag.current.startX;
    if (Math.abs(dx) > 4) drag.current.moved = true;
    scrollRef.current.scrollLeft = drag.current.startLeft - dx;
  };
  const endDrag = () => {
    drag.current.down = false;
  };

  return (
    <div className="w-full">
      {block.title && <SectionHeading titleSize={block.titleSize}>{block.title}</SectionHeading>}
      {block.subtitle && (
        <p className="mt-2 text-center text-sm text-white/60" style={block.subtitleSize ? { fontSize: `${block.subtitleSize}px` } : undefined}>{block.subtitle}</p>
      )}
      <div
        ref={scrollRef}
        onMouseDown={onDown}
        onMouseMove={onMove}
        onMouseUp={endDrag}
        onMouseEnter={pause}
        onMouseLeave={() => {
          endDrag();
          resume();
        }}
        onTouchStart={pause}
        onTouchEnd={resume}
        onTouchCancel={resume}
        className="no-scrollbar mt-4 flex cursor-grab gap-3 overflow-x-auto pb-2 active:cursor-grabbing"
        style={{ WebkitOverflowScrolling: "touch" }}
      >
        {renderItems.map((it, idx) => (
          <div
            key={`${it.id}-${idx}`}
            className="w-[46%] flex-none"
          >
            <div className="flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-white/5 backdrop-blur transition-transform duration-300 ease-out hover:scale-[1.05] active:scale-[1.05]">
              <div className="relative w-full" style={{ aspectRatio: "1 / 1" }}>
                {it.mediaType === "video" && it.video ? (
                  <AutoVideo
                    src={it.video}
                    className="absolute inset-0 h-full w-full object-cover"
                  />
                ) : it.image ? (
                  <img
                    src={it.image}
                    alt={it.title || ""}
                    draggable={false}
                    className="absolute inset-0 h-full w-full object-cover"
                  />
                ) : (
                  <div className="absolute inset-0 flex items-center justify-center bg-white/5 text-[10px] text-white/40">
                    Sin imagen
                  </div>
                )}
              </div>
              <div className="flex flex-1 flex-col p-3">
                {it.title && (
                  <p className="truncate text-center text-sm font-semibold text-white">
                    {it.title}
                  </p>
                )}
                {it.description && (
                  <p className="mt-1 line-clamp-2 text-center text-xs leading-snug text-white/60">
                    {it.description}
                  </p>
                )}
                {it.btnValue && (
                  <a
                    href={buildScheduleHref(it)}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      if (drag.current.moved) e.preventDefault();
                    }}
                    className="mt-2 flex items-center justify-center rounded-lg bg-blue-600 px-2 py-2 text-center text-xs font-semibold text-white transition hover:bg-blue-500"
                  >
                    {it.btnLabel || "Agendar"}
                  </a>
                )}
                {isStripeUrl(it.payLink) && (
                  <BuyButton
                    href={it.payLink}
                    small
                    className="mt-2 w-full"
                    onClick={(e) => {
                      if (drag.current.moved) e.preventDefault();
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      {mode !== "loop" && (
        <p className="mt-1 text-center text-[10px] text-white/30">
          Desliza para ver más →
        </p>
      )}
    </div>
  );
};

const DividerBlock = ({ block }) => {
  const c = block.color || "#2E6BFF";
  const soft = hexToRgba(c, 0.3);
  const grad = `linear-gradient(90deg, transparent, ${c}, transparent)`;
  const style = block.style || "gradient";
  let content;
  switch (style) {
    case "shimmer":
      content = (
        <div className="relative h-[2px] w-full overflow-hidden rounded-full" style={{ background: soft }}>
          <span className="div-shimmer absolute inset-y-0 left-0 w-1/3" style={{ backgroundImage: grad }} />
        </div>
      );
      break;
    case "dots":
      content = (
        <div className="flex gap-2.5">
          {[0, 1, 2, 3, 4].map((i) => (
            <span key={i} className="div-dot h-2 w-2 rounded-full" style={{ background: c, animationDelay: `${i * 0.15}s` }} />
          ))}
        </div>
      );
      break;
    case "pulse":
      content = <div className="div-pulse-line h-[3px] w-28 rounded-full" style={{ background: c }} />;
      break;
    case "glow":
      content = (
        <div className="relative flex w-full items-center">
          <div className="h-px w-full" style={{ background: soft }} />
          <span className="div-glow-dot absolute top-1/2 h-2.5 w-2.5 -translate-y-1/2 rounded-full" style={{ background: c, boxShadow: `0 0 10px ${c}` }} />
        </div>
      );
      break;
    case "dashed":
      content = <div className="div-dashed h-[3px] w-full" style={{ backgroundImage: `repeating-linear-gradient(90deg, ${c} 0 8px, transparent 8px 16px)` }} />;
      break;
    case "zigzag":
      content = (
        <svg width="150" height="16" viewBox="0 0 150 16" fill="none">
          <polyline points="0,12 15,4 30,12 45,4 60,12 75,4 90,12 105,4 120,12 135,4 150,12" stroke={c} strokeWidth="2" className="div-zig" />
        </svg>
      );
      break;
    case "star":
      content = (
        <div className="flex w-full items-center gap-3">
          <div className="h-px flex-1" style={{ background: soft }} />
          <Sparkles className="div-spin h-5 w-5" style={{ color: c }} />
          <div className="h-px flex-1" style={{ background: soft }} />
        </div>
      );
      break;
    case "diamond":
      content = (
        <div className="flex w-full items-center gap-3">
          <div className="h-px flex-1" style={{ background: soft }} />
          <span className="div-diamond h-3 w-3" style={{ background: c }} />
          <div className="h-px flex-1" style={{ background: soft }} />
        </div>
      );
      break;
    case "arrow":
      content = <ChevronDown className="div-bounce h-7 w-7" style={{ color: c }} />;
      break;
    case "wave":
      content = (
        <div className="w-40 overflow-hidden">
          <svg width="180" height="20" viewBox="0 0 180 20" fill="none" className="div-wave">
            <path d="M0 10 Q10 2 20 10 T40 10 T60 10 T80 10 T100 10 T120 10 T140 10 T160 10 T180 10" stroke={c} strokeWidth="2" />
          </svg>
        </div>
      );
      break;
    case "double":
      content = (
        <div className="w-full space-y-1.5">
          <div className="div-grad-slide h-[2px] w-full rounded-full" style={{ backgroundImage: grad }} />
          <div className="div-grad-slide div-grad-rev h-[2px] w-full rounded-full" style={{ backgroundImage: grad }} />
        </div>
      );
      break;
    case "gradient":
    default:
      content = <div className="div-grad-slide h-[3px] w-full rounded-full" style={{ backgroundImage: grad }} />;
  }
  return <div className="flex w-full items-center justify-center py-3">{content}</div>;
};

const YoutubeBlock = ({ block }) => {
  const [play, setPlay] = useState(false);
  const src = block.uploadUrl || block.url || "";
  const direct = !!block.uploadUrl || isDirectVideo(src);
  const yt = direct ? null : getYoutubeId(src);
  const vimeo = direct ? null : getVimeoId(src);
  const tiktok = direct ? null : getTikTokId(src);
  const insta = direct ? null : getInstagramEmbed(src);
  const fb = direct ? null : getFacebookEmbed(src);

  let content;
  if (direct) {
    const vsrc = block.uploadUrl || src;
    // Añadimos #t=0.1 para que iOS muestre el primer fotograma en vez de negro.
    const vsrcFrame = vsrc && vsrc.startsWith("/api/files/") ? withV(`${vsrc}#t=0.1`) : vsrc;
    content = (
      <video
        src={vsrcFrame}
        controls
        playsInline
        preload="metadata"
        className="mx-auto block max-h-[80vh] w-full bg-black object-contain"
      />
    );
  } else if (yt) {
    content = play ? (
      <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
        <iframe
          className="absolute inset-0 h-full w-full"
          src={`https://www.youtube.com/embed/${yt}?autoplay=1`}
          title={block.title || "Video"}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    ) : (
      <button
        onClick={() => setPlay(true)}
        className="group relative block w-full"
        style={{ paddingTop: "56.25%" }}
      >
        <img
          src={`https://img.youtube.com/vi/${yt}/hqdefault.jpg`}
          alt={block.title}
          className="absolute inset-0 h-full w-full object-cover"
        />
        <span className="absolute inset-0 bg-black/30 transition group-hover:bg-black/10" />
        <span className="absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-red-600 shadow-lg transition group-hover:scale-110">
          <Play className="h-7 w-7 translate-x-0.5 text-white" fill="white" />
        </span>
      </button>
    );
  } else if (vimeo) {
    content = (
      <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
        <iframe
          className="absolute inset-0 h-full w-full"
          src={`https://player.vimeo.com/video/${vimeo}`}
          title="Vimeo"
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  } else if (tiktok) {
    content = (
      <div className="relative mx-auto w-full" style={{ paddingTop: "150%", maxWidth: 360 }}>
        <iframe
          className="absolute inset-0 h-full w-full"
          src={`https://www.tiktok.com/embed/v2/${tiktok}`}
          title="TikTok"
          frameBorder="0"
          allow="autoplay; encrypted-media; fullscreen"
          allowFullScreen
        />
      </div>
    );
  } else if (insta) {
    content = (
      <div className="relative mx-auto w-full" style={{ paddingTop: "125%", maxWidth: 400 }}>
        <iframe
          className="absolute inset-0 h-full w-full"
          src={insta}
          title="Instagram"
          frameBorder="0"
          scrolling="no"
          allowFullScreen
        />
      </div>
    );
  } else if (fb) {
    content = (
      <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
        <iframe
          className="absolute inset-0 h-full w-full"
          src={fb}
          title="Facebook"
          frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
    );
  } else if (src) {
    content = (
      <div className="flex h-52 items-center justify-center px-6 text-center text-sm text-white/60">
        No se pudo incrustar este enlace. Intenta con YouTube, TikTok, Vimeo, Instagram o sube el video directamente.
      </div>
    );
  } else {
    content = (
      <div className="flex h-52 items-center justify-center text-sm text-white/50">
        Agrega un enlace o sube un video
      </div>
    );
  }

  return (
    <div className="w-full">
      {block.title && <SectionHeading titleSize={block.titleSize}>{block.title}</SectionHeading>}
      <div className="mt-4 overflow-hidden rounded-2xl border border-white/10 bg-black">
        {content}
      </div>
    </div>
  );
};

const MosaicGallery = ({ block }) => {
  const items = (block.items || []).filter((it) => it.image).slice(0, 12);
  if (!items.length) {
    return (
      <div className="w-full">
        {block.title && <SectionHeading titleSize={block.titleSize}>{block.title}</SectionHeading>}
        <p className="mt-4 text-center text-xs text-white/40">
          Agrega fotos para ver la galería mosaico.
        </p>
      </div>
    );
  }

  // Two columns floating in opposite directions (one up, one down), looping.
  const colA = items.filter((_, i) => i % 2 === 0);
  const colB = items.filter((_, i) => i % 2 === 1);

  const Photo = ({ it }) => (
    <div className="overflow-hidden rounded-2xl border border-white/10 shadow-lg">
      <img
        src={it.image}
        alt={it.caption || ""}
        loading="eager"
        className="block w-full object-cover"
      />
    </div>
  );

  const Column = ({ photos, dir }) => (
    <div className="flex-1">
      <div className={`mosaic-col ${dir === "up" ? "mosaic-col-up" : "mosaic-col-down"}`}>
        {[...photos, ...photos].map((it, i) => (
          <Photo key={`${it.id}-${i}`} it={it} />
        ))}
      </div>
    </div>
  );

  return (
    <div className="w-full">
      {block.title && <SectionHeading titleSize={block.titleSize}>{block.title}</SectionHeading>}
      <div className="mosaic-float mt-4 flex h-[440px] gap-2.5 overflow-hidden rounded-2xl">
        <Column photos={colA} dir="up" />
        {colB.length > 0 && <Column photos={colB} dir="down" />}
      </div>
    </div>
  );
};


const Gallery = ({ block }) => (
  <div className="w-full">
    {block.title && <SectionHeading titleSize={block.titleSize}>{block.title}</SectionHeading>}
    <div className="mt-4 grid grid-cols-2 gap-3">
      {(block.items || []).map((it) => (
        <div
          key={it.id}
          className="group relative overflow-hidden rounded-xl border border-white/10"
        >
          <img
            src={it.image}
            alt={it.caption}
            className="h-32 w-full object-cover transition-transform duration-700 group-hover:scale-110"
          />
          {it.caption && (
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-2">
              <span className="text-xs font-medium tracking-wide text-white">
                {it.caption}
              </span>
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
);

export const Block = ({ block, editable = false, live = false, portfolioId, profile = null }) => {
  switch (block.type) {
    case "heading":
      return (
        <SectionHeading style={textStyleFrom(block)} animClass={animClassFrom(block)} align={block.align || "center"}>
          {block.text}
        </SectionHeading>
      );
    case "text":
      return (
        <p
          className={`text-sm leading-relaxed text-white/70 break-words ${animClassFrom(block)}`}
          style={{ textAlign: block.align || "center", ...textStyleFrom(block) }}
        >
          {block.text}
        </p>
      );
    case "button": {
      const entry = block.icon ? buttonIconEntry(block.icon) : null;
      const defaultIcon =
        block.variant === "whatsapp"
          ? FaWhatsapp
          : block.variant === "email"
          ? Mail
          : block.variant === "pdf"
          ? PdfIcon
          : LinkIcon;
      const Icon = entry?.Icon || defaultIcon;
      const brandColor =
        entry?.color || (block.variant === "whatsapp" ? "#25D366" : "#2E6BFF");
      const hasColor = !!block.bgColor;
      const opacity =
        typeof block.opacity === "number" ? block.opacity : 100;
      const isGradient = block.fillType === "gradient";
      let btnStyle;
      if (isGradient) {
        const c1 = hexToRgba(block.gradColor1 || "#2E6BFF", opacity / 100);
        const c2 = hexToRgba(block.gradColor2 || "#8B5CF6", opacity / 100);
        const ang = typeof block.gradAngle === "number" ? block.gradAngle : 90;
        btnStyle = {
          background: `linear-gradient(${ang}deg, ${c1}, ${c2})`,
          borderColor: hexToRgba(block.gradColor2 || "#8B5CF6", Math.min(1, opacity / 100 + 0.2)),
          backdropFilter: opacity < 100 ? "blur(8px)" : "none",
        };
      } else if (hasColor) {
        btnStyle = {
          background: hexToRgba(block.bgColor, opacity / 100),
          borderColor: hexToRgba(block.bgColor, Math.min(1, opacity / 100 + 0.2)),
          backdropFilter: opacity < 100 ? "blur(8px)" : "none",
        };
      }
      const badgeBg = isGradient || hasColor ? "rgba(255,255,255,0.22)" : brandColor;
      const animClass =
        block.anim && block.anim !== "none" ? `btn-anim-${block.anim}` : "";
      const isOutline = (block.iconStyle || "solid") === "outline";
      const iconColor = block.iconColor || "#ffffff";
      const badgeStyle = isOutline
        ? { background: "transparent", border: `2px solid ${iconColor}` }
        : { background: badgeBg };
      const iconFinalColor = isOutline ? iconColor : "#ffffff";
      const shape = block.shape || "rounded";
      const borderColor = block.borderColor || "";
      const mergedStyle = {
        ...(btnStyle || {}),
        "--blb-border": borderColor || "rgba(255,255,255,0.55)",
      };
      if (borderColor) mergedStyle.borderColor = borderColor;
      return (
        <PdfAwareLink
          block={block}
          className={`brand-link-btn bsh bsh-${shape} ${animClass}`}
          style={mergedStyle}
        >
          <span
            className="blb-badge flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-lg"
            style={badgeStyle}
          >
            {block.iconImage ? (
              <img src={block.iconImage} alt="" className="h-full w-full object-cover" />
            ) : (
              <Icon className="h-[18px] w-[18px]" style={{ color: iconFinalColor }} />
            )}
          </span>
          <span
            className="min-w-0 flex-1 text-center font-display text-sm font-semibold tracking-wide"
            style={block.textColor ? { color: block.textColor } : undefined}
          >
            {block.label}
          </span>
          <ChevronRight className="blb-chevron h-4 w-4 shrink-0 text-white/40" />
        </PdfAwareLink>
      );
    }
    case "socials": {
      const style = block.style || "original";
      const iconColor = block.iconColor || "#ffffff";
      const size = block.iconSize || 48;
      return (
        <div className="flex flex-wrap justify-center gap-3">
          {(block.items || []).map((s) => {
            const { Icon, color } = socialBrand(s.platform);
            let boxStyle = {};
            let icoColor = "#ffffff";
            if (style === "original") {
              boxStyle = { background: color };
              icoColor = "#ffffff";
            } else {
              // transparente (recoloreable)
              boxStyle = { background: "transparent", border: `2px solid ${iconColor}` };
              icoColor = iconColor;
            }
            return (
              <a
                key={s.id}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center rounded-full transition hover:-translate-y-1 hover:brightness-110"
                style={{ width: size, height: size, ...boxStyle }}
              >
                <Icon style={{ color: icoColor, width: size * 0.45, height: size * 0.45 }} />
              </a>
            );
          })}
        </div>
      );
    }
    case "location":
      return (
        <div className="overflow-hidden rounded-2xl border border-white/10">
          <div className="relative">
            <img
              src={block.image}
              alt="Ubicación"
              className="h-40 w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 flex items-center gap-2 p-4">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-blue-600">
                <MapPin className="h-4 w-4 text-white" />
              </span>
              <span className="font-display text-sm font-semibold text-white">
                {block.label}
              </span>
            </div>
          </div>
          <div className="flex gap-2 bg-black/40 p-2.5 backdrop-blur">
            <a
              href={buildMapsHref(block)}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-1 items-center justify-center gap-1.5 rounded-lg bg-[#1a73e8] py-2 text-xs font-semibold text-white transition hover:brightness-110"
            >
              <MapPin className="h-4 w-4" />
              Maps
            </a>
            <a
              href={buildWazeHref(block)}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-1 items-center justify-center gap-1.5 rounded-lg bg-[#33ccff] py-2 text-xs font-semibold text-[#052b52] transition hover:brightness-105"
            >
              <FaWaze className="h-4 w-4" />
              Waze
            </a>
          </div>
        </div>
      );
    case "products":
      return <ProductCarousel block={block} />;
    case "showcase":
      return <ShowcaseCarousel block={block} />;
    case "showcase_strip":
      return <ShowcaseStrip block={block} />;
    case "divider":
      return <DividerBlock block={block} />;
    case "gallery":
      return <Gallery block={block} />;
    case "mosaic":
      return <MosaicGallery block={block} />;
    case "pay":
      return <PayBlock block={block} SectionHeading={SectionHeading} />;
    case "flyers":
      return <Flyers360 block={block} SectionHeading={SectionHeading} />;
    case "mosaic_h":
      return <MosaicHorizontal block={block} SectionHeading={SectionHeading} />;
    case "youtube":
      return <YoutubeBlock block={block} />;
    case "vcard":
      return <VCardBlock block={block} profile={profile} />;
    case "reviews":
      return <ReviewsBlock block={block} live={live} portfolioId={portfolioId} />;
    case "menu":
      return <MenuBlock block={block} />;
    case "countdown":
      return <CountdownBlock block={block} />;
    case "timeline":
      return <TimelineBlock block={block} />;
    case "audio":
      return <AudioBlock block={block} editable={editable} />;
    case "stories":
      return <StoriesBlock block={block} />;
    case "image":
      return <ImageBlock block={block} />;
    case "qr":
      return <QrBlock block={block} />;
    default:
      return null;
  }
};

export const ProfileHeader = ({ profile, animate = false }) => {
  const size = profile.avatarSize || 112; // px, default = old h-28/w-28
  const badgeStyle = BADGE_STYLES[profile.badgeStyle] || BADGE_STYLES.check;
  const BadgeIcon = badgeStyle.icon;
  const badgeSize = Math.max(20, Math.round(size * 0.19));
  const isVideo = profile.avatarType === "video";
  const posX = typeof profile.avatarPosX === "number" ? profile.avatarPosX : 50;
  const posY = typeof profile.avatarPosY === "number" ? profile.avatarPosY : 50;
  const zoom = typeof profile.avatarZoom === "number" ? profile.avatarZoom : 1;
  const objectPosition = `${posX}% ${posY}%`;
  const mediaStyle = { objectPosition, transform: `scale(${zoom})`, transformOrigin: `${posX}% ${posY}%` };
  const frame = profile.avatarFrame || "none";
  const frameColor = profile.avatarFrameColor || "#2E6BFF";
  const media = profile.avatar ? (
    isVideo ? (
      <AutoVideo src={profile.avatar} className="h-full w-full object-cover" style={mediaStyle} />
    ) : (
      <img src={profile.avatar} alt={profile.businessName} className="h-full w-full object-cover" style={mediaStyle} />
    )
  ) : (
    <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-blue-500 to-indigo-600 font-display text-3xl font-bold text-white">
      {(profile.businessName || "U").charAt(0)}
    </div>
  );
  return (
    <div className={`flex flex-col items-center text-center ${animate ? "rise-in" : ""}`}>
      <div className="relative" style={{ width: size, height: size }}>
        {frame === "none" ? (
          <div className="h-full w-full overflow-hidden rounded-full border-4 border-white/20 shadow-2xl">
            {media}
          </div>
        ) : (
          <div
            className={`pf-frame pf-fr-${frame} h-full w-full`}
            style={frame === "manual" ? { "--pf-color": frameColor } : undefined}
          >
            <div className="pf-frame-inner">{media}</div>
          </div>
        )}
        {profile.verified && (
          <span
            className={`pf-verified-badge absolute flex items-center justify-center rounded-full shadow-lg ring-2 ring-white ${badgeStyle.bg}`}
            style={{ width: badgeSize, height: badgeSize, right: "6%", bottom: "6%" }}
            data-testid="verified-badge"
          >
            <BadgeIcon
              className="text-white"
              style={{ width: badgeSize * 0.66, height: badgeSize * 0.66 }}
            />
          </span>
        )}
      </div>
      <h1 className="mt-4 font-display text-2xl font-bold text-white">
        {profile.businessName}
      </h1>
      <p className="mt-2 max-w-xs text-sm leading-relaxed text-white/65">
        {profile.subtitle}
      </p>
    </div>
  );
};

const REVEAL_VARIANTS = ["up", "left", "right", "zoom"];

const PortfolioRenderer = ({ portfolio, animate = true }) => {
  if (!portfolio) return null;
  const { profile, blocks = [] } = portfolio;

  // In the editor preview (animate=false) we render statically.
  if (!animate) {
    return (
      <div className="relative min-h-full w-full overflow-x-hidden">
        <PortfolioBackground background={portfolio.background} />
        <div className="relative z-10 mx-auto flex w-full max-w-md flex-col gap-6 px-5 pb-16 pt-10">
          {portfolio.kind === "card" ? (
            <CoverHeader portfolio={portfolio} />
          ) : (
            <ProfileHeader profile={profile} />
          )}
          {blocks.map((block) => (
            <div key={block.id}>
              <Block block={block} profile={profile} />
            </div>
          ))}
          <div className="mt-4 flex flex-col items-center gap-1">
            <span className="text-[11px] text-white/40">Creado con</span>
            <span className="font-display text-sm font-bold tracking-wide text-white/80">
              UAICARD <span className="text-blue-400">BUSINESS</span>
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="relative min-h-full w-full overflow-x-hidden">
      <PortfolioBackground background={portfolio.background} />
      <div className="relative z-10 mx-auto flex w-full max-w-md flex-col gap-6 px-5 pb-16 pt-10">
        {/* Header with entrance animation */}
        <Reveal variant="up">
          {portfolio.kind === "card" ? (
            <CoverHeader portfolio={portfolio} />
          ) : (
            <ProfileHeader profile={profile} />
          )}
        </Reveal>

        {/* Blocks reveal on scroll, alternating direction for a dynamic feel */}
        {blocks.map((block, i) => (
          <Reveal
            key={block.id}
            variant={REVEAL_VARIANTS[i % REVEAL_VARIANTS.length]}
            delay={i < 4 ? i * 90 : 0}
          >
            <Block block={block} live portfolioId={portfolio.id} profile={profile} />
          </Reveal>
        ))}

        {/* Footer */}
        <Reveal variant="up">
          <div className="mt-4 flex flex-col items-center gap-1">
            <span className="text-[11px] text-white/40">Creado con</span>
            <span className="font-display text-sm font-bold tracking-wide text-white/80">
              UAICARD <span className="text-blue-400">BUSINESS</span>
            </span>
          </div>
        </Reveal>
      </div>
    </div>
  );
};

export default PortfolioRenderer;
